import ApiResourceManager from '../ApiResourceManager';
import ReduxHooks from '../../../store/ReduxHooks';
import { actionCreators } from '../../../store/actions';

export default class PaypalConnectionManager extends ApiResourceManager {
  connect = async (clientId, clientSecret) => {
    const response = await this.request({
      method: 'POST',
      url: '/paypal/connection',
      data: { client_id: clientId, client_secret: clientSecret },
    });

    if (response.success) {
      ReduxHooks.dispatch(actionCreators.currentCompany.set(response.data));
    }

    return response;
  };

  disconnect = async () => {
    const response = await this.request({
      method: 'DELETE',
      url: '/paypal/connection',
    });

    if (response.success) {
      ReduxHooks.dispatch(actionCreators.currentCompany.set(response.data));
    }

    return response;
  };
}
